module.exports = __webpack_public_path__ + "img/token_player_faq_page.e0cb9a1b.png";